import script from "./SolutionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SolutionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SolutionsPage.vue?vue&type=style&index=0&id=49acc990&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49acc990"]])

export default __exports__